<template>
	<div class="wc-package-product-img">
		<BaseUiImage loading="lazy" :data="data?.item?.image_thumb" :alt="data.item.title" />
	</div>
</template>

<script setup>
	const {generateThumbs} = useImages();
	const props = defineProps(['data'])

	generateThumbs({
		data: props.data.item,
		preset: 'cartPackage'
	})
</script>

<style lang="less" scoped>
	.wc-package-product-img{
		display: flex; align-items: center; justify-content: center; width: 64px; height: 64px; margin: 0 10px 10px 0;
		:deep(img){display: block; width: auto; height: auto; max-width: 100%; max-height: 100%;}

		@media (max-width: @m){width: 54px; height: 54px; margin: 0 5px 10px 0;}
	}
</style>
